import { render, staticRenderFns } from "./MainLogIn.vue?vue&type=template&id=64da5e3e&"
import script from "./MainLogIn.vue?vue&type=script&lang=js&"
export * from "./MainLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports